import { useWindowDimensions, Platform } from 'react-native';

const BREAKPOINTS = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
};

export const useScreenSize = () => {
    const { width, height } = useWindowDimensions();

    // On native mobile, we generally consider it "mobile" unless it's a large tablet
    // On web, we respect the width breakpoints
    const isWeb = Platform.OS === 'web';

    const isMobile = width < BREAKPOINTS.md;
    const isTablet = width >= BREAKPOINTS.md && width < BREAKPOINTS.lg;
    const isDesktop = width >= BREAKPOINTS.lg;

    // Specific Mobile checks
    const isSmallMobile = width < 375; // iPhone SE size
    const isLargeMobile = width >= 375 && width < BREAKPOINTS.md; // iPhone 14 Pro max size range

    return {
        width,
        height,
        isMobile,
        isTablet,
        isDesktop,
        isSmallMobile,
        isLargeMobile,
        breakpoints: BREAKPOINTS,
    };
};
